const edit = {

	init() {


		// Toon of verberg uitdienst datum
		$('#Type').on('change, blur', function(e) {
			e.preventDefault();
			var einddatumVerplicht = $('#Type option:selected').data('einddatum');

			if (einddatumVerplicht == true) {
				$('input#Einddatum').attr('data-validate', 'required date daterange').val($('input#Einddatum').attr('data-valueOrg')).attr('placeholder', $('input#Begindatum').attr('placeholder'));
				$('input#Einddatum').datepicker('update');
			} else {
				// TODO: Controle of veld daadwerkelijk zichtbaar is!
				$('input#Einddatum').attr('data-validate', '').attr('placeholder', $('input#Einddatum').attr('data-placeholderNietVerplicht'));
			}
		});

		$('#Type').trigger('change');

		// laad de datum kiezer voor einddatum op basis van de begindatum
		$('#Begindatum').on('change, blur', function(e) {
			e.preventDefault();
			$('input#Einddatum').attr('data-enddate', $('input#Begindatum').attr('data-enddate'));
			// $('input#Einddatum').data('datepicker').setEndDate($('input#Begindatum').attr('data-enddate')); // omgezet naar onderstaande regel wegens error na bundling
			$('input#Einddatum').datepicker('setEndDate', $('input#Begindatum').attr('data-enddate'));

			$('input#Einddatum').attr('data-startdate', $('input#Begindatum').val());
			// $('input#Einddatum').data('datepicker').setStartDate($('input#Begindatum').val()); // omgezet naar onderstaande regel wegens error na bundling
			$('input#Einddatum').datepicker('setStartDate', $('input#Begindatum').val());
		});

		// Toon of verberg het blok voor overlappend dienstverband op basis van de begindatum voor een nieuw dienstverband en de einddatum van reeds bestaande dienstverbanden.
		$('#Begindatum, #Einddatum, #Type').change(function(e) {
			e.preventDefault();
			if ($('#Begindatum').val() != '') {
				$.getJSON(window.app.ajaxPath + $('#form-signalering').data('signalering_id') + '/' + '-' + '/duplicate-check/' + $('#Type').val() + '/' + $('#Begindatum').val() + '/' + $('#Einddatum').val() + '/' + '/', function(data) {
					if (data != false) {
						// Er is een overlappend dienstverband
						if (!$('#form_suggestion').is(':visible')) {
							$('#form_suggestion').hide().removeClass('d-none').fadeIn();
							$('#form_continue').hide();
						}

						$('.gevonden-signaleringen *').remove();
						$.each(data, function(index, val) {
							var tr = '<tr><td>' + val.begindatum + '</td><td>' + val.einddatum + '</td><td>' + $('#Type option[value="' + val.type + '"]').text() + '</td></tr>';
							$('.gevonden-signaleringen').append(tr);
						});
						$('#form_continue button').html('Toch opslaan');

					} else {
						$('#form_suggestion').fadeOut(100, function() {
							$('#form_continue button').html('Opslaan');
						});
					}
					$('#form_continue').hide().removeClass('d-none').fadeIn();
				});
			}
		});

		$('#Begindatum').trigger('change');

		// Focus op bovenste veld wanneer pagina geladen is
		$(function() {
			$('#Begindatum').focus();
		});

	}

};

export default edit;
